export enum HideNewsComments {
  Hide = 'Hide',
  HideIfNoComments = 'HideIfNoComments',
}
